<script setup lang="ts">
import { CheckboxItem } from '@shared/ui/checkbox'

import { useTutorApplicationStore } from '../../model/store'
import { useAcceptEmailDelivery } from '../../model/legal-agreements/accept-email-delivery.hooks'

defineOptions({
  name: 'AcceptEmailDelivery',
})

const tutorApplicationStore = useTutorApplicationStore()

const {
  mode,
  label,
  setAcceptEmailDelivery,
} = useAcceptEmailDelivery()

</script>

<template>
  <CheckboxItem
    :label="label"
    required
    :checked="tutorApplicationStore.form.acceptEmailDelivery"
    :mode="mode"
    @click="setAcceptEmailDelivery"
  />
</template>
